<template>
	<div class="component">
		<template v-if="allow">
			<button v-if="!open" @click="open = true">
				<i class="fa fa-cog" aria-hidden="true"></i>
			</button>
			<div class="set" v-else>
				<div class="uploadBg">
					<label for="uploadBg">
						<h5>Выберите фон</h5>
						<p class="btn-primary btn">Загрузить</p>
					</label>
					<input
						id="uploadBg"
						hidden
						type="file"
						accept="image/jpeg, image/png"
						@change="uploadBg"
					/>
				</div>
				<button @click="open = false" class="close-btn">
					<i class="fa fa-times" aria-hidden="true"></i>
				</button>

				<template v-if="!!testingBg">
					<hr />
					<h5>Текущий тестируемый фон:</h5>
					<img :src="testingBg" class="img" alt="" />
					<div>
						<button class="btn-danger btn" @click="saveBg">Сохранить</button>
						<button class="btn-secondary btn" @click="removeBg">Удалить</button>
					</div>
				</template>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	data: () => {
		return {
			file: null,
			open: true,
		}
	},

	computed: {
		testingBg() {
			return this.$store.state.testingBg
		},
		allow() {
			return this.$store.state.myProfile?.role === 'super franchise'
		},
	},

	methods: {
		uploadBg({
			target: {
				files: [file],
			},
		}) {
			this.$store.commit('changeTestingBg', URL.createObjectURL(file))
			this.file = URL.createObjectURL(file)
		},
		removeBg() {
			this.$store.commit('changeTestingBg', '')
		},
		saveBg() {
			this.axios({
				method: 'patch',
				url: `eshop/items/purchased/${this.$store.state.myProfile.id}/activate`,
				data: {
					item: {
						file: bg,
					},
				},
			})
		},
	},
}
</script>

<style scoped lang="scss">
.uploadBg {
	display: flex;
	padding-right: 30px;
	flex-direction: column;
}

.component {
	position: fixed;
	bottom: 0;
	right: 0;
	z-index: 10000;
}

.open-btn {
	width: 40px;
	height: 40px;
	background: #fff;
	border: none;
	border-left: 2px solid #000;
	border-top: 2px solid #000;
	border-top-left-radius: 5px;
	font-size: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.set {
	background: #fff;
	padding: 15px;
	border: 1px solid #333;

	label {
		font-weight: bold;
		font-size: 1.4rem;
		line-height: 1em;
		bottom: 0;
	}
}

.close-btn {
	padding: 4px;
	position: absolute;
	top: 10px;
	right: 10px;
	background: #fff;
	border: none;
	display: flex;
	justify-content: center;
	align-items: center;
}

.img {
	max-height: 150px;
	border: 1px solid #000;
	display: block;
	margin-bottom: 16px;
	width: auto;
}
</style>
